// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7e57cb3","667":"2e525326","977":"728b67c9"}[chunkId] + ".chunk.js";
};